<template>
  <v-dialog v-model="dialog" scrollable persistent transition="dialog-bottom-transition">
    <v-card class="mx-auto">
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-toolbar class="flex-grow-0" dark color="primary">
        <v-toolbar-title>Vinho</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" lg="8">
                <v-text-field v-model="editedItem.name" :counter="250" :rules="[rules.required, rules.counter]"
                  label="Nome" required></v-text-field>

                <v-textarea v-model="editedItem.description" rows="11" label="Descrição"></v-textarea>
              </v-col>

              <v-col cols="12" lg="2">
                <v-card height="300">
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Imagem Principal</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn icon dark @click="$refs.inputUpload.click()">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <input v-show="false" accept=".png, .jpg, .jpeg" ref="inputUpload" id="inputUpload" type="file"
                      @change="AddInitFile()" />
                    <v-card v-show="mainPics.length != 0" width="200" style="margin: 0 auto;">
                      <v-img style="cursor: pointer !important;" :src="mainPics[0] ? mainPics[0].path : ''" contain
                        @click="handleGalery(mainPics, 1)" width="200" height="150" aspect-ratio="1"
                        class="grey lighten-2" />

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red" text @click="deletePhoto(mainPics, 0)">Eliminar</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                    <gallery ref="gallery" :index="imgIndex" :images="auxImgs" @close="imgIndex = null"></gallery>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" sm="6" lg="2">
                <v-text-field v-model="editedItem.capacity" label="Capacidade" prefix="L" type="number"
                  :rules="[rules.isValidFloat]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" lg="2">
                <v-text-field v-model="editedItem.temperature" label="Temperatura" :counter="250"
                  :rules="[rules.required, rules.counter]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" lg="2">
                <v-text-field v-model="editedItem.volume" label="Volume" prefix="%" type="number"
                  :rules="[rules.isValidFloat, rules.zero, rules.hundred]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" lg="2">
                <v-text-field v-model="editedItem.year" label="Ano" type="number"
                  :rules="[rules.isValidInt, rules.zero]"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" lg="2">
                <v-text-field v-model="editedItem.price" label="Preço" prefix="€" type="number"
                  :rules="[rules.isValidFloat, rules.zero]"></v-text-field>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" lg="10">
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Imagens</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-btn icon dark @click="$refs.inputUploadMulti.click()">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-card-text>
                    <input v-show="false" accept=".png, .jpg, .jpeg" ref="inputUploadMulti" id="inputUploadMulti"
                      type="file" multiple @change="AddMultiFile()" />

                    <div v-show="images.length != 0" ref="picsDiv" style="height:250px; 
    width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;">
                      <ul class="ulPics" ref="picsUl">
                        <li v-for="(c, i) in images" :key="i">
                          <v-card>
                            <v-img style="cursor: pointer !important;" :src="c.path" contain
                              @click="handleGalery(images, i)" width="200" height="150" aspect-ratio="1"
                              class="grey lighten-2" />
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="red" text @click="deletePhoto(images, i)">Eliminar</v-btn>
                              <v-spacer></v-spacer>
                            </v-card-actions>
                          </v-card>
                        </li>
                      </ul>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" lg="10">
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Castas</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="refresh">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <multi-selector :title="'Castas'" :fullItems="castes"
                      :existingItems="editedItem.Castes"></multi-selector>
                  </v-toolbar>
                  <ul>
                    <li v-for="(c, i) in editedItem.Castes" :key="i">{{ c.name }}</li>
                  </ul>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" lg="10">
                <v-card>
                  <v-toolbar dark color="primary">
                    <v-toolbar-title>Comida</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="refresh">
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                    <multi-selector :title="'Comida'" :fullItems="food"
                      :existingItems="editedItem.Food"></multi-selector>
                  </v-toolbar>
                  <ul>
                    <li v-for="(c, i) in editedItem.Food" :key="i">{{ c.name }}</li>
                  </ul>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" lg="10">
                <v-card>
                  <v-toolbar class="flex-grow-0" dark color="blue lighten-1">
                    <v-card-title class="headline">Prémios</v-card-title>

                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon rounded @click.stop="addUpdateAward()">
                            <v-icon v-on="on">mdi-plus</v-icon>
                          </v-btn>
                        </template>
                        <span>Adicionar</span>
                      </v-tooltip>
                    </v-toolbar-items>
                  </v-toolbar>
                  <v-data-table :headers="headers" :items="editedItem.Awards" hide-default-footer
                    :items-per-page.sync="editedItem.Awards.length + 10" class="elevation-1">
                    <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                    <template v-slot:item.action="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon class="mx-0" @click.stop="addUpdateAward(item)">
                            <v-icon v-on="on" color="green">mdi-pencil</v-icon>
                          </v-btn>
                        </template>
                        <span>Editar</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn icon class="mx-0" @click.stop="removeAward(item)">
                            <v-icon v-on="on" color="pink">mdi-delete</v-icon>
                          </v-btn>
                        </template>
                        <span>Eliminar</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>

            <v-row justify="center">
              <v-col cols="12" lg="10">
                <v-autocomplete v-model="editedItem.RegionId" :items="regions" item-text="name" item-value="id"
                  label="Região" :rules="[rules.required]" clearable><template v-slot:append-outer>
                    <v-icon @click="refresh">mdi-refresh</v-icon>
                  </template></v-autocomplete>

                <v-autocomplete v-model="editedItem.TypeId" :items="types" item-text="description" item-value="id"
                  label="Tipo" :rules="[rules.required]" clearable><template v-slot:append-outer>
                    <v-icon @click="refresh">mdi-refresh</v-icon>
                  </template></v-autocomplete>

                <v-autocomplete v-model="editedItem.WineryId" :items="wineries" item-text="name" item-value="id"
                  label="Vinicola" :rules="[rules.required]" clearable><template v-slot:append-outer>
                    <v-icon @click="refresh">mdi-refresh</v-icon>
                  </template></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="save(false)">Guardar e Adicionar Outro</v-btn>
        <v-btn color="blue darken-1" text @click="save(true)">Guardar e Sair</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogAward" max-width="600px" scrollable persistent transition="dialog-bottom-transition">
      <v-card>
        <v-card-title>
          <span class="headline">{{ awardFormTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="formAward" v-model="validAward">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field @keydown.enter="saveAward" ref="awardDesc" v-model="editedAward.description"
                    :counter="250" :rules="[rules.required, rules.counter]" label="Descrição"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeAwardForm">Fechar</v-btn>
          <v-btn color="blue darken-1" text @click="saveAward">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import _ from "lodash";
import VueGallery from "vue-gallery";
import MultiSelector from "./MultiSelector";

export default {
  name: "CreateUpdateWine",
  props: ["regions", "types", "wineries", "overlay", "castes", "food"],
  components: {
    gallery: VueGallery,
    MultiSelector
  },
  data: () => ({
    dialog: false,
    valid: true,
    validAward: true,
    filterDialog: false,
    fab: false,
    page: 1,
    items: [],
    busy: false,
    loading: true,
    savingInfo: false,
    editedIndex: -1,
    name: null,
    description: null,
    editedItem: {
      name: "",
      description: "",
      capacity: "",
      price: "",
      temperature: "",
      volume: "",
      year: "",
      TypeId: null,
      WineryId: null,
      RegionId: null,
      Food: [],
      Castes: [],
      Awards: [],
      id: null
    },
    defaultItem: {
      name: "",
      description: "",
      capacity: "",
      price: 0,
      temperature: "",
      volume: "",
      year: "",
      TypeId: null,
      WineryId: null,
      RegionId: null,
      Food: [],
      Castes: [],
      Awards: [],
      id: null
    },
    defaultAward: {
      id: null,
      description: null
    },
    editedAward: {
      id: null,
      description: null
    },
    editedAwardIndex: -1,
    headers: [
      {
        text: "Descrição",
        align: "start",
        sortable: true,
        value: "description"
      },
      { text: "Actions", value: "action", sortable: false, align: "end" }
    ],
    rules: {
      required: value => !!value || "Campo Obrigatório.",
      isValidInt: value =>
        /(?<=\s|^)\d+(?=\s|$)/.test(value) || "Valor inválido",
      isValidFloat: value =>
        /^[-+]?([0-9]+(\.[0-9]+)?|\.[0-9]+)$/.test(value) || "Valor inválido",
      counter: value =>
        (value && value.length <= 250) ||
        "Campo tem de ter menos de 250 caracteres",
      zero: v => v >= 0 || "Valor tem de ser >= 0",
      hundred: v => v <= 100 || "Valor tem de ser <= 100"
    },
    returnIndex: -1,
    imgIndex: -1,
    mainPics: [],
    images: [],
    auxImgs: [],
    dialogAward: false
  }),
  methods: {
    async open(wine, index) {
      this.returnIndex = index;
      if (wine) {
        this.editedItem = Object.assign({}, wine);
        this.mainPics = _.filter(wine.Images, ["is_main", true]);
        this.images = _.filter(wine.Images, ["is_main", false]);
      } else {
        this.editedItem = Object.assign({}, this.defaultItem);
      }

      this.dialog = true;
    },
    removeAward(item) {
      this.editedItem.Awards.splice(this.editedItem.Awards.indexOf(item), 1);
    },
    addUpdateAward(item) {
      if (item) {
        this.editedAwardIndex = this.editedItem.Awards.indexOf(item);
        this.editedAward = Object.assign({}, item);
      } else {
        this.editedAward = Object.assign({}, this.defaultAward);
      }

      this.dialogAward = true;
      requestAnimationFrame(() => {
        return this.$refs.awardDesc.$refs.input.focus()
      });
    },
    closeAwardForm() {
      this.dialogAward = false;
      this.$refs.formAward.reset();
      this.$refs.formAward.resetValidation();
      this.$nextTick(() => {
        this.editedAward = Object.assign({}, this.defaultAward);
        this.editedAwardIndex = -1;
      });
    },
    saveAward() {
      if (this.$refs.formAward.validate()) {
        if (this.editedAwardIndex > -1) {
          Object.assign(
            this.editedItem.Awards[this.editedAwardIndex],
            this.editedAward
          );
        } else {
          this.editedItem.Awards.push(Object.assign({}, this.editedAward));
        }
        this.closeAwardForm();
      }
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.mainPics = [];
        this.images = [];
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.Castes = [];
        this.returnIndex = -1;
      });
    },
    reset() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$nextTick(() => {
        this.mainPics = [];
        this.images = [];
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.Castes = [];
        this.returnIndex = -1;
      });
    },
    save(close) {
      if (this.$refs.form.validate()) {
        this.$emit(
          "saveChanges",
          this.editedItem,
          this.returnIndex,
          this.mainPics,
          this.images,
          close
        );
      }
    },
    AddInitFile() {
      var filesize = (
        this.$refs.inputUpload.files[0].size /
        1024 /
        1024
      ).toFixed(4); // MB

      if (filesize > 2) {
        alert("Tamanho máximo do ficheiro é 2MB");
        return;
      }

      var reader = new FileReader();

      reader.addEventListener(
        "load",
        () => {
          this.mainPics = [];
          this.mainPics.push({
            id: null,
            path: reader.result,
            name: this.$refs.inputUpload.files[0].name
          });
        },
        false
      );

      if (this.$refs.inputUpload.files[0]) {
        reader.readAsDataURL(this.$refs.inputUpload.files[0]);
      }
    },
    AddMultiFile() {
      _.each(this.$refs.inputUploadMulti.files, item => {
        var filesize = (item.size / 1024 / 1024).toFixed(4); // MB

        if (filesize > 2) {
          alert("Tamanho máximo do ficheiro é 2MB");
          this.images = [];
          return;
        }

        var reader = new FileReader();

        reader.addEventListener(
          "load",
          () => {
            this.images.push({
              id: null,
              path: reader.result,
              name: item.name
            });
          },
          false
        );

        if (item) {
          reader.readAsDataURL(item);
        }
      });

      this.$refs.inputUploadMulti.value = '';
    },
    handleGalery(srcArray, index) {
      this.auxImgs = [];
      _.each(srcArray, item => {
        this.auxImgs.push(item.path);
      });
      this.imgIndex = index;
    },
    deletePhoto(srcArray, index) {
      this.$refs.inputUpload.value = '';
      this.$emit("deletePhoto", srcArray, index);
    },
    refresh() {
      this.$emit("refresh");
    }
  },
  computed: {
    awardFormTitle() {
      return this.editedAwardIndex === -1 ? "Novo Prémio" : "Editar Prémio";
    }
  }
};
</script>

<style scoped>
.ulPics {
  height: 100%;
  list-style-type: none;
  padding: 10px;
  display: -webkit-inline-box;
}

ul li {
  padding: 10px;
  height: 100%;
}

li img {
  height: 100%;
  width: 300px;
  cursor: pointer;
}

.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
  cursor: pointer !important;
}
</style>
